import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { DialogBaseComponent } from "../../base-admin-panel/dialog-base/dialog-base.component";
import { GeozoneViewModel } from "../Model/GeozoneViewModel";
import { ZoneService } from "../../../../services/zones.service";
import { IManagableObject } from "../../IManagableObject";
import { ObjectsService } from "../../../../services/objects.service";
import { ObjectModel } from "../../../../models/ObjectModel";
import { IconViewModel } from "../../../../models/IconViewModel";
import { ContainersService } from "../../../../services/containers.service";
import { ContainerViewModel } from "../../ContainerViewModel";
import { ContainerAcl } from "app/models/ContainerAcl";

declare var g_Profile: any;

@Component({
  selector: 'app-geozone-edit',
  templateUrl: './geozone-edit.component.html',
  styleUrls: ['./geozone-edit.component.css'],
  standalone: false
})
export class GeozoneEditComponent extends DialogBaseComponent<GeozoneViewModel> implements OnInit {
  private zonesService: ZoneService;
  private copyOfModel: GeozoneViewModel;
  private interval = null;

  private objectsService: ObjectsService;
  private containersService: ContainersService;
  public Objects: ObjectModel[] = [];
  public ObjectGroups: IManagableObject[] = [];
  public containers: ContainerViewModel[] = [];
  public creatableContainers: ContainerViewModel[] = [];

  @Input()
  public Icons: IconViewModel[] = [];
  currentUser: import("../../../../services/users.service").UserViewModel;

  @Input('model')
  set onModelSet(model: GeozoneViewModel | undefined) {
    this.model = model ?? new GeozoneViewModel();
    const flags = this.model.Flags ?? "";
    this.useInReports = flags.indexOf("NOUSEREPORT") < 0;
    this.events = flags.replace("NOUSEREPORT", '').replace(" ", '');
    this.ensureContainerSelected();
  }

  constructor(protected injector: Injector) {
    super(injector);
    this.zonesService = injector.get(ZoneService);
    this.objectsService = injector.get(ObjectsService);
    this.containersService = injector.get(ContainersService);
  }

  public groups: IManagableObject[] = [];

  @Output()
  public zoneChange: EventEmitter<string> = new EventEmitter<string>();

  ngOnInit() {
    this.model = this.model ?? new GeozoneViewModel();
    this.currentUser = this.usersService.getCurrentUser();

    this.zonesService.GetGroups()
      .subscribe(groups => {
        this.groups = groups;
      });
    this.objectsService.GetObjects()
      .subscribe(items => {
        this.Objects = items;
      });
    this.objectsService.GetObjectGroups()
      .subscribe(items => {
        this.ObjectGroups = items;
      });
    this.loadContainers();

    if (this.model.Id && this.model.Id > 0) {
      g_Profile.zones.Select(g_Profile.zones.GetObject(this.model.Id))
      /*this.zonesService.GetZoneGroups(this.model.Id)
        .subscribe(groups => {
          this.model.Groups = groups.map(g => g.Id);
        });*/
    }

    this.interval = setInterval(() => this.TestChanges(), 1000);
  }

  public events: string = "";
  public useInReports: boolean = false;

  @Output()
  public onClose: EventEmitter<any> = new EventEmitter<any>();
  public openedTabName: string = "Main";

  public onStrokeChanged(color) {
    this.model.Style.strokeColor = color;
  }

  public onFillChanged(color) {
    this.model.Style.fillColor = color;
  }

  public get isEditMode(): boolean {
    return (this.model?.Id ?? 0) > 0;
  }

  private ensureContainerSelected() {
    if (!this.model) return;

    const availableContainers = this.isEditMode ? this.containers : this.creatableContainers;
    if (availableContainers.length === 0) {
      if (!this.isEditMode)
        this.model.ContainerId = undefined;
      return;
    }

    if (this.model.ContainerId && availableContainers.some(x => x.Id === this.model.ContainerId)) return;
    this.model.ContainerId = availableContainers[0].Id;
  }

  private loadContainers() {
    const companyId = this.usersService.getCurrentUser()?.CompanyId;
    if (!companyId) {
      this.containers = [];
      this.creatableContainers = [];
      if (!this.isEditMode)
        this.model.ContainerId = undefined;
      return;
    }

    this.containersService.GetContainers()
      .subscribe(items => {
        this.containers = [...(items ?? [])]
          .sort((a, b) => (a.Name ?? "").localeCompare(b.Name ?? ""));
        this.creatableContainers = this.getCreatableContainers(this.containers);
        this.ensureContainerSelected();
      });
  }

  public getSelectedContainerName(): string {
    const containerId = this.model?.ContainerId;
    if (!containerId) return "";
    return this.containers.find(x => x.Id === containerId)?.Name ?? "";
  }

  private getCreatableContainers(containers: ContainerViewModel[]): ContainerViewModel[] {
    return containers.filter(container =>
      (this.getContainerAcl(container) & ContainerAcl.CreateGeozone) === ContainerAcl.CreateGeozone);
  }

  private getContainerAcl(container: ContainerViewModel): number {
    if (!this.currentUser)
      return 0;

    if (this.currentUser.CanDo(this.AccessRights.EDITUSERS) || this.currentUser.CanDo(this.AccessRights.EDIT_ALL_USERS))
      return ContainerAcl.CreateGeozone | ContainerAcl.EditGeozone | ContainerAcl.DeleteGeozone;

    const userId = this.currentUser.Id;
    const aclFromUsers = container.Users?.find(link => link.UserId === userId)?.ACL;
    const fallbackAcl = (this.currentUser.ContainerLinks ?? []).find(link => link.ContainerId === container.Id)?.ACL;
    return aclFromUsers ?? fallbackAcl ?? 0;
  }


  private TestChanges() {
    if (!this.model)
      return;

    if (!this.model.IsEqual(this.copyOfModel)) {
      this.copyOfModel = this.model.Clone();
      this.zoneChange.emit();
    }
  }

  close() {
    this.model = new GeozoneViewModel();

    super.close();
    //this.onClose.emit();

    window.clearInterval(this.interval);
  }

  protected onEdit() {
    this.onCreated.emit();
    this.syncService.NotifyEntityChanged("Geozone", this.model.Id);
    super.submit();
    this.close();
  }

  submit() {
    this.model.Flags = this.events;
    this.model.Flags += this.useInReports ? "" : " NOUSEREPORT";
    if (this.model.IconId == 0)
      this.model.IconId = undefined;

    if (!this.model.Name) {
      this.toastr.error(this.translate.instant("Name is required"));
      return;
    }
    this.model.GroupIds = this.model.Groups;
    if (!this.model.ContainerId) {
      this.toastr.error(this.translate.instant("Container is required"));
      return;
    }

    if (this.model.Id == 0) {
      this.zonesService.CreateZone(this.model)
        .subscribe((res) => {
          this.zonesService.SetObjects(res['id'], this.model.Objects);
          this.onEdit();
        });
    }
    else {
      this.zonesService.EditZone(this.model)
        .subscribe((res) => {
          this.zonesService.SetObjects(this.model.Id, this.model.Objects);
          this.onEdit();
        });
    }
  }

  public openTab(tabName: string) {
    this.openedTabName = tabName;
  }
  public redraw() {
    this.model.Points = "";
    this.zoneChange.emit();
  }
}
